"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var Store = /*#__PURE__*/function () {
  function Store() {
    var _this2 = this;
    _classCallCheck(this, Store);
    this.stringUtils = new StringUtils();
    this.numberUtils = new NumberUtils();
    this.limitForExtraOrder = 5000; // USD

    this.initStore();
    this._storeFormEl = "#frm-storeForm";
    this._customFieldBundleIdWrapper = "#customfield-bundleId";
    this._customFieldBundleIdRequired = 'input[name="bundleId_required"]';
    this._processSubmitButtonEl = 'input[name="process"]';
    this._detailOrderWrapper = '.detailOrderWrapper';
    this._extraOrderEl = '.extra-order';
    this._nonExtraOrderEl = '.non-extra-order';
    this._inputPersonalInformationRequired = 'input[name="personal_info_required"]';
    this._storeForm = "_storeForm";
    this.trackSendingDuration();

    // AJAX FORM SENT
    $.nette.ext(this._storeForm, {
      before: function before(jqXHR, settings) {
        if (settings.nette && settings.nette.el) {
          if (_this2.isInCorrespondingSection(settings.nette.form)) {
            $(settings.nette.el).addClass("sending");
            $(settings.nette.el).attr("data-clicked", Date.now());
            var selectedItems = 0;
            $(".quantity:enabled", "." + _this2._storeForm).each(function (index, item) {
              var quantity = parseInt($(item).val());
              if (quantity > 0) {
                selectedItems += quantity;
              }
            });
            if (selectedItems > 0) {
              $(".store-error-selected-items").hide();
            } else {
              $(".store-error-selected-items").show();
              jqXHR.abort();
              $(settings.nette.el).removeClass("sending");
            }
          }
        }
      },
      complete: function complete(jqXHR, status, settings) {
        if (settings.nette && settings.nette.el) {
          if (_this2.isInCorrespondingSection(settings.nette.form)) {
            NavigationUtils.scrollToElement($("#buy-headline"), -_this2.getHeaderHeight());
            $(settings.nette.el).removeClass("data-clicked");
            $(settings.nette.el).removeClass("sending");
            var totalQuantity = 0;
            $(".quantity:enabled", "." + _this2._storeForm).each(function (index, item) {
              var quantity = parseInt($(item).val());
              if (quantity > 0) {
                totalQuantity += quantity;
              }
            });
            gtag('event', 'form', {
              'event_category': "send",
              'event_label': "not-confirmed-order",
              'event_value': totalQuantity
            });
          }
        }
      }
    });
  }
  _createClass(Store, [{
    key: "isInCorrespondingSection",
    value: function isInCorrespondingSection(el) {
      return $(el).hasClass(this._storeForm);
    }
  }, {
    key: "trackSendingDuration",
    value: function trackSendingDuration() {
      var _this = this;
      var submitButton = $(this._processSubmitButtonEl, this._storeFormEl);
      setInterval(function () {
        var timestampClickedString = submitButton.attr("data-clicked");
        if (typeof timestampClickedString !== "undefined") {
          var currentDatTime = new Date();
          var timestampClicked = new Date(parseInt(timestampClickedString));
          var seconds = (currentDatTime.getTime() - timestampClicked.getTime()) / 1000;
          if (seconds > 8) {
            submitButton.removeAttr("data-clicked");
            _this.removeSendingClassFromSubmitFormButton(submitButton);
          }
        } else {
          _this.removeSendingClassFromSubmitFormButton(submitButton);
        }
      }, 1000);
    }
  }, {
    key: "removeSendingClassFromSubmitFormButton",
    value: function removeSendingClassFromSubmitFormButton(el) {
      el.removeClass("sending");
    }
  }, {
    key: "initStore",
    value: function initStore() {
      this._quantity = $("input.quantity");
      this._selectProductRadioInput = ".selectProduct";
      this._minusQuantityButton = $("button.minusQuantity");
      this._plusQuantityButton = $("button.plusQuantity");
      this._premiumSupportChk = $("input[type='checkbox'].selectGlobalPremiumSupportChk");
      this._buyBlock = $(".buy-block");
      this.setSectionType();
      this.initWatchClickPlusQuantityButton();
      this.initWatchClickMinusQuantityButton();
      this.initWatchClickQuantityInput();
      this.initWatchManualChangeQuantity();
      this.initWatchProductQuantityChange();
      this.initWatchClickSelectProduct();
      this.initWatchClickSelectProductChk();
      this.initWatchClickGlobalPremiumSupportChk();
      $(this._storeFormEl).trigger("reset");
      $(this._processSubmitButtonEl, this._storeFormEl).removeClass("sending");
      $(this._processSubmitButtonEl, this._storeFormEl).removeAttr("data-clicked");

      //$(this._selectProductRadioInput).trigger('change',{'isTriggeredBySystem':true})
      //$(".selectProductChk").trigger('change',{'isTriggeredBySystem':true});
      var _this = this;
      setTimeout(function () {
        var firstInit = true;
        $("input.quantity").each(function (index, item) {
          var quantity = _this.getProductQuantity($(item));
          var product = _this.getElementParentProduct($(item));
          if (quantity > 0) {
            firstInit = false;
            $(item).trigger("click", {
              "force": true
            });
            $(item).val(quantity);
            if ($(".selectProductChk", product).length > 1) {
              $(".selectProductChk", product).prop('checked', true);
            }
          }
          $(item).change();
        });
        if (firstInit) {
          $("input.quantity").each(function (index, item) {
            var quantity = _this.getProductQuantity($(item));
            var product = _this.getElementParentProduct($(item));
            if (product.attr("data-select-default") === "true") {
              $(".selectProduct", product).prop('checked', true).attr("data-active", 1).trigger('change', {
                'isTriggeredBySystem': true
              });
            }
          });
        }
        if (_this._premiumSupportChk.length > 0) {
          _this._premiumSupportChk.change();
        }
      }, 100);
    }
  }, {
    key: "initWatchClickSelectProduct",
    value: function initWatchClickSelectProduct() {
      var _this3 = this;
      var _this = this;
      $(document).on("click", _this._selectProductRadioInput, function (e) {
        var radioInput = $(this);
        var radioGroup = radioInput.attr("name");
        if (radioInput.attr("data-active") === "1") {
          $(_this._selectProductRadioInput + '[name="' + radioGroup + '"]').attr("data-active", 0);
          radioInput.prop("checked", false);
          radioInput.trigger('change', {
            'isTriggeredBySystem': true
          });
        } else {
          $(_this._selectProductRadioInput + '[name="' + radioGroup + '"]').attr("data-active", 0);
          radioInput.attr("data-active", 1);
          radioInput.prop("checked", true);
          radioInput.trigger('change', {
            'isTriggeredBySystem': true
          });
        }
      });
      $(this._selectProductRadioInput).change(function (e) {
        var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        if ("isTriggeredBySystem" in o) {
          var _this4 = $(e.currentTarget);
          var product = _this3.getElementParentProduct(_this4);
          var buyBlock = _this3.getProductParentBuyBlock(product);
          var input = _this3.getProductNumberInput(product);
          if (_this4.is(':checked')) {
            _this3.setProductAsActive(product);
            _this3.setProductAsEnabled(input);
            input.attr("min", input.attr("data-min"));
            _this3.setProductQuantity(product, input.attr("data-min"));
          } else {
            _this3.setProductAsInactive(product);
            _this3.setProductQuantity(product, 0);
            input.attr("min", 0);
          }
          input.change();
          $(".product", buyBlock).not(product).each(function (index, item) {
            // SET PRODUCT AS INACTIVE - SET QUANTITY TO 0
            _this3.setProductAsInactive(item);
            _this3.setProductQuantity(item, 0);
            var input = _this3.getProductNumberInput(item);
            input.attr("min", 0);
            //this.setProductAsDisabled(input);
            input.change();
          });
        }
      });
    }
  }, {
    key: "initWatchClickSelectProductChk",
    value: function initWatchClickSelectProductChk() {
      var _this5 = this;
      $(".selectProductChk").change(function (e) {
        var _this = $(e.currentTarget);
        var product = _this5.getElementParentProduct(_this);
        var input = _this5.getProductNumberInput(product);
        if (_this.prop('checked')) {
          _this5.setProductAsActive(product);
          if (product.attr("data-disabled-change-quantity") === "false") {
            input.attr("min", input.attr("data-min"));
            _this5.setProductQuantity(product, input.attr("data-min"));
          }
          //this.setProductAsEnabled(input);
        } else {
          _this5.setProductAsInactive(product);
          //this.setProductAsDisabled(input);
          if (product.attr("data-disabled-change-quantity") === "false") {
            _this5.setProductQuantity(product, 0);
            input.attr("min", 0);
          }
        }
        input.change();
      });
    }
  }, {
    key: "initWatchClickGlobalPremiumSupportChk",
    value: function initWatchClickGlobalPremiumSupportChk() {
      var _this6 = this;
      this._premiumSupportChk.change(function (e) {
        var _this = _this6;
        var premiumChk = $(e.currentTarget);
        var ps_checkboxes = premiumChk.parents(_this6._buyBlock).find(".product_ps .selectProductChk");
        ps_checkboxes.each(function () {
          var product_quantity = $(this).parents(".product").find("input.quantity");
          var productNumberInput = product_quantity;
          var quantity = _this.getProductQuantity(productNumberInput);
          if (quantity != 0) {
            $(this).prop("checked", premiumChk.prop("checked"));
            $(this).change();
          } else {
            $(this).prop("checked", false);
            $(this).change();
          }
          if ($(this).is(':checked')) {
            _this.setProductAsEnabled(productNumberInput);
          } else {
            _this.setProductAsDisabled(productNumberInput);
          }
        });
      });
    }
  }, {
    key: "setSectionType",
    value: function setSectionType() {
      var _this7 = this;
      this._buyBlock.each(function (index, item) {
        var blockGroupSection = index;
        var sectionType = $(item).attr("data-store-type");
        if (sectionType === "sli") {
          $(".product", item).each(function (index, product) {
            var productNameEle = $(".name", product);

            // SET PRODUCT AS INACTIVE - SET QUANTITY TO 0
            _this7.setProductAsInactive(product);
            _this7.setProductQuantity(product, 0);
            var input = _this7.getProductNumberInput(product);
            input.change();

            // ADD CHECKBOX BEFORE PRODUCT NAME
            productNameEle.prepend("<input type='radio' name='selectProduct" + blockGroupSection + "[]' class='selectProduct'>");
          });
        } else if (sectionType === "chk") {
          $(".product", item).each(function (index, product) {
            var productNameEle = $(".name", product);
            var input = _this7.getProductNumberInput(product);
            _this7.setProductAsInactive(product);
            //this.setProductAsDisabled(input);
            //input.attr("min", input.attr("data-min"));
            //this.setProductQuantity(product, input.attr("data-min"));

            input.change();

            // ADD CHECKBOX BEFORE PRODUCT NAME
            productNameEle.prepend("<input type='checkbox' name='selectProductChk' class='selectProductChk'>");
          });
        }
      });
    }
  }, {
    key: "initWatchClickQuantityInput",
    value: function initWatchClickQuantityInput() {
      var _this = this;
      $(document).on("click", "input.quantity", function (e, o) {
        var product = _this.getElementParentProduct($(this));
        var input = _this.getProductNumberInput(product);
        var productEnabledByClick = _this.enableProductThroughtCheckboxOrRadionButton(product, o);

        /*if(!productEnabledByClick) {
            this.plusOneQuantityToInput(product, input);
            input.change();
        }*/
      });
    }
  }, {
    key: "initWatchClickPlusQuantityButton",
    value: function initWatchClickPlusQuantityButton() {
      var _this8 = this;
      var _this = this;
      this._plusQuantityButton.click(function (e) {
        var _this = $(e.currentTarget);
        var product = _this8.getElementParentProduct(_this);
        var input = _this8.getProductNumberInput(product);
        var productEnabledByClick = _this8.enableProductThroughtCheckboxOrRadionButton(product);
        if (!productEnabledByClick) {
          _this8.plusOneQuantityToInput(product, input);
          input.change();
        }
      });
    }
  }, {
    key: "initWatchManualChangeQuantity",
    value: function initWatchManualChangeQuantity() {
      this._quantity.keyup(function (e) {
        var _this = $(e.currentTarget);
        var min = parseInt(_this.attr('min')) || 0;
        var max = parseInt(_this.attr('max')) || "";
        var val = parseInt(_this.val()) || 0;
        if (val < min) {
          _this.val(min);
        } else if (max !== "" && val > max) {
          _this.val(max);
        } else {
          _this.val(val);
        }
      });
    }
  }, {
    key: "plusOneQuantityToInput",
    value: function plusOneQuantityToInput(product, input) {
      var min = parseInt(input.attr("min"));
      var max = parseInt(input.attr("max"));
      var quantity = this.getProductQuantity(input);
      var newQuantity = quantity + 1;
      if (newQuantity > max) {
        this.setProductQuantity(product, quantity);
      } else {
        if (newQuantity < min) {
          this.setProductQuantity(product, min);
        } else {
          this.setProductQuantity(product, newQuantity);
        }
      }
    }
  }, {
    key: "initWatchClickMinusQuantityButton",
    value: function initWatchClickMinusQuantityButton() {
      var _this9 = this;
      this._minusQuantityButton.click(function (e) {
        var _this = $(e.currentTarget);
        var product = _this9.getElementParentProduct(_this);
        var input = _this9.getProductNumberInput(product);
        _this9.minusOneQuantityToInput(product, input);
        input.change();
      });
    }
  }, {
    key: "minusOneQuantityToInput",
    value: function minusOneQuantityToInput(product, input) {
      var min = parseInt(input.attr("min"));
      var max = parseInt(input.attr("max"));
      var quantity = this.getProductQuantity(input);
      var newQuantity = quantity - 1;
      if (newQuantity < min) {
        var enabled = this.disableProductThroughtCheckboxOrRadionButton(product);
        //if(!enabled) {
        this.setProductQuantity(product, 0);
        //}
      } else {
        this.setProductQuantity(product, newQuantity);
      }
    }
  }, {
    key: "enableProductThroughtCheckboxOrRadionButton",
    value: function enableProductThroughtCheckboxOrRadionButton(product) {
      var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var _this = this;
      if ($(".selectProductChk", product).length > 0) {
        if (!$(".selectProductChk", product).is(':checked') || "force" in config) {
          $(".selectProductChk", product).prop('checked', true).trigger('change', {
            'isTriggeredBySystem': true
          });
          return true;
        }

        //$(".selectProductChk", product).trigger('change', {'isTriggeredBySystem': true})
      }
      if ($(_this._selectProductRadioInput, product).length > 0) {
        var radioInput = $(_this._selectProductRadioInput, product);
        var radioGroup = radioInput.attr("name");
        if (radioInput.attr("data-active") !== "1") {
          $(_this._selectProductRadioInput + '[name="' + radioGroup + '"]').attr("data-active", 0);
          radioInput.prop("checked", true);
          radioInput.attr("data-active", 1);
          radioInput.trigger('change', {
            'isTriggeredBySystem': true
          });
          return true;
        }
      }
      return false;
    }
  }, {
    key: "disableProductThroughtCheckboxOrRadionButton",
    value: function disableProductThroughtCheckboxOrRadionButton(product) {
      var _this = this;
      if ($(".selectProductChk", product).length > 0) {
        if ($(".selectProductChk", product).is(':checked')) {
          $(".selectProductChk", product).prop('checked', false).change();
          return true;
        }
      }
      if ($(_this._selectProductRadioInput, product).length > 0) {
        var radioInput = $(_this._selectProductRadioInput, product);
        var radioGroup = radioInput.attr("name");
        if (radioInput.attr("data-active") === "1") {
          $(_this._selectProductRadioInput + '[name="' + radioGroup + '"]').attr("data-active", 0);
          radioInput.prop("checked", false);
          radioInput.trigger('change', {
            'isTriggeredBySystem': true
          });
          return true;
        }
      }
      return false;
    }
  }, {
    key: "initWatchProductQuantityChange",
    value: function initWatchProductQuantityChange() {
      var _this10 = this;
      this._quantity.change(function (e) {
        var productNumberInput = $(e.currentTarget);
        var form = _this10.getForm(productNumberInput);
        var formSubmitButton = _this10.getSubmitButton(form);
        var productNumberInputName = productNumberInput.attr("name");
        var product = _this10.getElementParentProduct(productNumberInput);
        var productProperties = _this10.getProductProperties(product);
        var quantity = _this10.getProductQuantity(productNumberInput);
        var setSameQuantityFor = product.attr("data-same-quantity-for");
        var setPairedWith = product.attr("data-paired-with");
        var setPairedMinQuantity = product.attr("data-paired-min-quantity");
        var dataPairedMinCache = "data-paired-min-cache";
        if (setSameQuantityFor !== "") {
          var productMinor = $(".product[data-product-id='" + setSameQuantityFor + "']");
          _this10.setProductQuantity(productMinor, quantity);
          _this10.getProductNumberInput(productMinor).change();
          if (productMinor.hasClass('product_ps')) {
            _this10._premiumSupportChk.change();
          }
        }
        if (setPairedWith !== "") {
          var productPairMinor = $(".product[data-product-id='" + setPairedWith + "']");
          var input = _this10.getProductNumberInput(productPairMinor);
          if (setPairedMinQuantity !== "") {
            if (quantity > 0) {
              if (_this10.getProductQuantity(input) < setPairedMinQuantity) {
                _this10.setProductQuantity(productPairMinor, setPairedMinQuantity);
              }
              if (input.attr(dataPairedMinCache) == "") {
                input.attr(dataPairedMinCache, input.attr("min"));
                input.attr("data-min", setPairedMinQuantity);
                input.attr("min", setPairedMinQuantity);
              }
              _this10.getProductNumberInput(productPairMinor).change();
            } else {
              if (input.attr(dataPairedMinCache) !== "") {
                input.attr("data-min", input.attr(dataPairedMinCache));
                input.attr("min", input.attr(dataPairedMinCache));
                input.attr(dataPairedMinCache, "");
              }
              _this10.getProductNumberInput(productPairMinor).change();
            }
          }
          if (productPairMinor.hasClass('product_ps')) {
            _this10._premiumSupportChk.change();
          }
        }
        if (productProperties.discounts === "false") {
          var totalPrice = quantity * Number(productProperties.piece_price);
          _this10.setProductTotalPrice(product, totalPrice);
          _this10.setProductPiecePrice(product, Number(productProperties.piece_price));
        } else {
          var discounts = JSON.parse(productProperties.discounts);
          var piecePrice = _this10.calculatePiecePrice(productProperties.piece_price, quantity, discounts);
          var _totalPrice = quantity * piecePrice;
          _this10.setProductTotalPrice(product, _totalPrice);
          _this10.setProductPiecePrice(product, piecePrice);
        }
        _this10.openDetailOrderDetail();
        _this10.sumTotalPrice();
      });
    }

    // Funkce pro výpočet ceny za kus
  }, {
    key: "calculatePiecePrice",
    value: function calculatePiecePrice(basePrice, quantity, discounts) {
      var pricePerUnit = Number(basePrice);

      // Určení typu slevy
      var isPercentageDiscount = typeof Object.values(discounts)[0] === "number";
      if (isPercentageDiscount) {
        // Procentuální sleva
        var applicableDiscount = Object.keys(discounts).map(Number).filter(function (key) {
          return key <= quantity;
        }).sort(function (a, b) {
          return b - a;
        })[0];
        if (applicableDiscount) {
          var discountPercentage = discounts[applicableDiscount];
          pricePerUnit = basePrice * (1 - discountPercentage / 100);
        }
      } else {
        // Pevná sleva
        var _applicableDiscount = Object.keys(discounts).map(Number).filter(function (key) {
          return key <= quantity;
        }).sort(function (a, b) {
          return b - a;
        })[0];
        if (_applicableDiscount) {
          var discountValue = discounts[_applicableDiscount].USD;
          pricePerUnit = basePrice - discountValue;
        }
      }
      return pricePerUnit;
    }
  }, {
    key: "openDetailOrderDetail",
    value: function openDetailOrderDetail() {
      var totalQuantity = 0;
      var _this = this;
      var requiredCustomFieldBundleId = 0;
      this._quantity.each(function (index, item) {
        var name = $(item).attr("name");
        var quantity = parseInt($(item).val());
        var product = _this.getElementParentProduct($(item));
        var requiredCustomFieldsRaw = product.attr("data-customfield");
        if (quantity > 0) {
          if (requiredCustomFieldsRaw.length > 0) {
            var requiredCustomFields = JSON.parse(requiredCustomFieldsRaw);
            if (requiredCustomFields.includes("bundleId")) {
              requiredCustomFieldBundleId = 1;
            }
          }
        }
        totalQuantity += quantity;
      });
      if (totalQuantity > 0) {
        $(_this._detailOrderWrapper).slideDown();
      } else {
        $(_this._detailOrderWrapper).slideUp();
      }

      // BUNDLE ID - CUSTOM FIELD
      if (requiredCustomFieldBundleId) {
        $(_this._customFieldBundleIdWrapper).show();
        $(_this._customFieldBundleIdRequired).val(1).change();
      } else {
        $(_this._customFieldBundleIdRequired).val(0).change();
        $(_this._customFieldBundleIdWrapper).hide();
      }
    }
  }, {
    key: "getForm",
    value: function getForm(element) {
      return element.parents("form");
    }
  }, {
    key: "getSubmitButton",
    value: function getSubmitButton(form) {
      return form.find("input[type='submit'");
    }
  }, {
    key: "getProductParentBuyBlock",
    value: function getProductParentBuyBlock(product) {
      return product.parents(".buy-block");
    }
  }, {
    key: "setProductAsEnabled",
    value: function setProductAsEnabled(input) {
      $(input).prop('disabled', false);
    }
  }, {
    key: "setProductAsDisabled",
    value: function setProductAsDisabled(input) {
      $(input).prop('disabled', true);
    }
  }, {
    key: "setProductAsInactive",
    value: function setProductAsInactive(product) {
      $(product).attr("data-active", "false");
      //$(".quantity", product).attr("readonly", "true");
      //this.setProductQuantity(product, 0);
    }
  }, {
    key: "setProductAsActive",
    value: function setProductAsActive(product) {
      $(product).attr("data-active", "true");
      //$(".quantity", product).removeAttr("readonly");
      //this.setProductQuantity(product, 1);
    }
  }, {
    key: "setProductQuantity",
    value: function setProductQuantity(product, quantity) {
      $(".quantity", product).val(quantity);
    }
  }, {
    key: "getPiecePriceDiscountByQuantity",
    value: function getPiecePriceDiscountByQuantity(rprice, qty) {
      var prev = -1;
      var i;
      var lastDiscount = Object.keys(rprice)[Object.keys(rprice).length - 1];
      if (qty >= lastDiscount) {
        return rprice[lastDiscount]["USD"];
      } else {
        for (i in rprice) {
          var n = parseInt(i);
          if (prev != -1 && qty < n) {
            return rprice[prev]["USD"];
          } else {
            prev = n;
          }
        }
      }
    }
  }, {
    key: "getProductQuantity",
    value: function getProductQuantity(input) {
      return parseInt(input.val());
    }
  }, {
    key: "getProductNumberInput",
    value: function getProductNumberInput(product) {
      return $("input.quantity", product);
    }
  }, {
    key: "getProductProperties",
    value: function getProductProperties(product) {
      return {
        total_price: product.attr("data-total-price"),
        piece_price: product.attr("data-piece-price"),
        discounts: product.attr("data-discounts")
      };
    }
  }, {
    key: "getElementParentProduct",
    value: function getElementParentProduct(ele) {
      return ele.parents(".product");
    }
  }, {
    key: "sumTotalPrice",
    value: function sumTotalPrice() {
      var _this11 = this;
      var totalPrice = 0;
      $(".total-price").each(function (index, item) {
        var product = _this11.getElementParentProduct($(item));
        var productActive = product.attr('data-active');
        if (_typeof(productActive) !== (typeof undefined === "undefined" ? "undefined" : _typeof(undefined)) && productActive !== false) {
          if (productActive === "true") {
            var priceString = $(item).attr("data-price");
            totalPrice += _this11.numberUtils.roundNumber(priceString);
          }
        } else {
          var _priceString = $(item).attr("data-price");
          totalPrice += _this11.numberUtils.roundNumber(_priceString);
        }
      });
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      this.evaluationToExternFormDueExtraOrder(totalPrice);
      /*if(totalPrice > 5000){
          $(".extra-order").show();
          $(".non-extra-order").hide();
          $('input[name="personal_info_required"]').val(1).trigger("change");
          $(this._processSubmitButtonEl, this._storeFormEl).val($(this._processSubmitButtonEl, this._storeFormEl).attr("data-extra-order-label"));
       } else {
          $(".extra-order").hide();
          $(".non-extra-order").show();
          $('input[name="personal_info_required"]').val(0).trigger("change");
          $(this._processSubmitButtonEl, this._storeFormEl).val($(this._processSubmitButtonEl, this._storeFormEl).attr("data-non-extra-order"));
       }*/

      $(".total-sum-price span").html(formatter.format(totalPrice));
    }

    /**
     * In case that order is higer then some limit the form with order will expand about new fields and insted of using FastSpring the e-mail will be send
     * @param totalPrice
     */
  }, {
    key: "evaluationToExternFormDueExtraOrder",
    value: function evaluationToExternFormDueExtraOrder(totalPrice) {
      var _this = this;
      if (totalPrice >= _this.limitForExtraOrder) {
        $(_this._extraOrderEl).show();
        $(_this._nonExtraOrderEl).hide();
        $(_this._inputPersonalInformationRequired).val(1).trigger("change");
        $(this._processSubmitButtonEl, this._storeFormEl).val($(this._processSubmitButtonEl, this._storeFormEl).attr("data-extra-order-label"));
      } else {
        $(_this._extraOrderEl).hide();
        $(_this._nonExtraOrderEl).show();
        $(_this._inputPersonalInformationRequired).val(0).trigger("change");
        $(this._processSubmitButtonEl, this._storeFormEl).val($(this._processSubmitButtonEl, this._storeFormEl).attr("data-non-extra-order"));
      }
    }
  }, {
    key: "setProductTotalPrice",
    value: function setProductTotalPrice(product, price) {
      var priceFinal = this.numberUtils.roundNumber(price);
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      $(".total-price", product).attr("data-price", priceFinal);
      this.setPremiumSupportTotalPrice(product);
      return $(".total-price span", product).html(formatter.format(priceFinal));
    }
  }, {
    key: "setPremiumSupportTotalPrice",
    value: function setPremiumSupportTotalPrice(product) {
      var _this = this;
      if (product.hasClass('product_ps')) {
        var priceFinal = 0;
        var section = product.parents(_this._buyBlock);
        var section_ps_items = section.find(".product_ps");
        var premiumSupportChk = section.find(_this._premiumSupportChk);
        section_ps_items.each(function () {
          priceFinal = priceFinal + _this.numberUtils.roundNumber($(".total-price", this).attr("data-price"));
        });
        var formatter = new Intl.NumberFormat('en-US', {
          style: 'currency',
          currency: 'USD',
          minimumFractionDigits: 2
        });
        return $(".total-price-ps span", section).html(formatter.format(priceFinal));
      }
    }
  }, {
    key: "setProductPiecePrice",
    value: function setProductPiecePrice(product, price) {
      var priceFinal = this.numberUtils.roundNumber(price);
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
      });
      return $(".price-per-piece span", product).html(formatter.format(priceFinal));
    }
  }]);
  return Store;
}();